/* eslint-disable no-nested-ternary */
import { useState, useEffect, useMemo, useContext } from 'react';
import { Card, Col, Row, Form, Input, Button, message } from 'antd';
import useHttpClient from 'shared/hooks/http-hook';
import { AuthContext } from 'shared/context/auth-context';
import EndPoints from 'shared/endPoints/EndPoints.json';
import exportToExcel from 'shared/utils/exportToExcel';
import Validations from 'shared/validations/Validations.json';
import { usePackage } from './Package/package-context';
import PackingForm from './Package/PackingForm';

export default function NewDevice() {
  const [excelData, setExcelData] = useState();
  const [useNewSIMOnNewDevice, setUseNewSIMOnNewDevice] = useState();
  const [isDisplayUseNewSIM, setIsDisplayUseNewSIM] = useState();
  const GL = 1;
  const GDP = 2;
  const PCL = 3 ;
  const { UserId } = useContext(AuthContext);
  const [form] = Form.useForm();
  const [newDeviceForm] = Form.useForm();
  const {
    capacity,
    deviceTypeId,
    carrierCompanyId,
    remainingCapacity,
    barcodePrint,
    isNew,
    parcelId,
    deviceType,
    carrierCompany,
    useNewSIM,
    updateRemaingCapacity
  } = usePackage();

  const {
    sendRequest,
    responseData,
    requestIdentifier,
    responseMessage,
    errorMessage,
    status
  } = useHttpClient();

  const layout = {
    labelCol: {
      span: 3
    },
    wrapperCol: {
      span: 6
    }
  };

  const excelColumns = useMemo(
    () =>
      [
        {
          title: 'ΙΜΕΙ Συσκευής',
          dataIndex: 'imei',
          key: 'imei',
          type: [GL, GDP, PCL]
        },
        {
          title: 'ΙΜSΙ Sim Κάρτας',
          dataIndex: 'imsi',
          key: 'imsi',
          type: [GL, GDP]
        },
        {
          title: 'Τύπος Συσκευής',
          dataIndex: 'deviceType',
          key: 'deviceType',
          type: [GL, GDP, PCL]
        },
        {
          title: 'MacAddress',
          dataIndex: 'macAddress',
          key: 'macAddress',
          type: [PCL]
        },
        {
          title: 'Α/Α',
          dataIndex: 'parcelId',
          key: 'parcelId',
          type: [GL, GDP, PCL]
        }
      ].filter(item => item.type.indexOf(deviceTypeId) !== -1),
    [deviceTypeId]
  );

  const addnewDevice = values => {
    const data = {
      simImsi: values.imsi,
      deviceImei: values.imei,
      parcelId,
      applicationUserId: UserId,
      deviceTypeId,
      macAddress: values.macAddress
    };
    if (!isNew) {
      sendRequest(
        {
          endpoint: EndPoints.PACKING.PUTPACKING,
          method: 'PUT',
          data
        },
        'PUTPACKING',
        'Η συσκευή επεξεργάστηκε με επιτυχία',
        'Η επεξεργασία της συσκευής ήταν ανεπιτυχής'
      );
    } else {
      sendRequest(
        {
          endpoint: EndPoints.PACKING.POSTPACKING,
          method: 'POST',
          data
        },
        'POSTPACKING',
        'Η συσκευή καταχωρήθηκε με επιτυχία',
        'Η καταχώρηση της συσκευής ήταν ανεπιτυχής'
      );
    }
    newDeviceForm.resetFields();
  };

  const setRequestParameters = () => {
    if (deviceTypeId < PCL) return {endpoint: EndPoints.PACKING.GETIMSISIM, requestId:'GETSIM', errorMsg:'Δε βρέθηκε SIM'}
    return {endpoint: EndPoints.PACKING.GETMACADDRESS, requestId:'GETMAC', errorMsg:'Δε βρέθηκε MAC ADDRESS'}
  }

  const onChangeInputImeiDevice = async () => {
    try {
      await newDeviceForm.validateFields(['imei']);
      if (!useNewSIM && !isNew) {
        const requestParameters = setRequestParameters();
        sendRequest(
          {
            endpoint: `${requestParameters.endpoint}/${newDeviceForm.getFieldValue('imei')}`,
            method: 'GET',
            data: null
          },
          requestParameters.requestId,
          null,
          requestParameters.errorMsg
        );
      }
    } catch (errors) {
      newDeviceForm.resetFields(['imsi', 'macAddress']);
    }
  };

  const onPreventFormSubmitByEnterKey = e => {
    if (e.keyCode === 13) e.preventDefault();
  };

  useEffect(() => {
    if (
      (responseData && requestIdentifier === 'POSTPACKING') ||
      (responseData && requestIdentifier === 'PUTPACKING')
    ) {
      sendRequest(
        {
          endpoint: `${
            EndPoints.PARCEL.GETPARCELBYUSER
          }/${UserId}`,
          method: 'GET',
          data: null
        },
        'GETPARCELBYUSER'
      );
    }
  }, [sendRequest, requestIdentifier, responseData, UserId]);

  useEffect(() => {
    if (responseData && requestIdentifier === 'GETPARCELBYUSER') {
      form.setFieldsValue({
        remainingCapacity: responseData.remainingCapacity
      });
      updateRemaingCapacity(responseData.remainingCapacity);
    }
    if (
      responseData &&
      status === 'resolved' &&
      requestIdentifier === 'GETSIM'
    ) {
      newDeviceForm.setFieldsValue({ imsi: responseData.imsi });
    }

    if (
      responseData &&
      status === 'resolved' &&
      requestIdentifier === 'GETMAC'
    ) {
      newDeviceForm.setFieldsValue({ macAddress: responseData.macAddress });
    }
  }, [
    responseData,
    form,
    requestIdentifier,
    newDeviceForm,
    remainingCapacity,
    status,
    useNewSIM,
    updateRemaingCapacity
  ]);

  useEffect(() => {
    if (responseData && requestIdentifier === 'GETEXCELDATA') {
      setExcelData(responseData);
      exportToExcel(excelColumns, responseData);
    }
  }, [requestIdentifier, responseData, excelColumns]);

  useEffect(() => {
    form.setFieldsValue({
      capacity,
      deviceType: deviceTypeId,
      carrierCompany: carrierCompanyId,
      remainingCapacity,
      barcodePrint,
      isNew: !isNew,
      PackageId: parcelId,
      useNewSIM: useNewSIMOnNewDevice
    });
    setIsDisplayUseNewSIM(isNew);
    updateRemaingCapacity(remainingCapacity);
  }, [
    form,
    parcelId,
    capacity,
    deviceTypeId,
    carrierCompanyId,
    remainingCapacity,
    barcodePrint,
    isNew,
    useNewSIMOnNewDevice,
    updateRemaingCapacity
  ]);

  

  const getErrorMessage = data => {
    let result;
      Object.keys(data).forEach(key => {
        result = data[key];
      });
      if (result[0] === 'Device does not exist.')
        return 'Η συσκευή δεν υπάρχει';
      if (result === 'Device is initialized.')
        return 'Η συσκευή έχει αρχικοποιηθεί.';
      if (result === 'Device should be null.')
        return 'Η συσκευή πρέπει να είναι κενή';
      if (result === 'Sim is in use.') 
        return 'Η Sim είναι σε χρήση';
      return null
  }

  useEffect(() => {
    if (
      (requestIdentifier === 'POSTPACKING' || requestIdentifier === 'PUTPACKING') 
        && status === 'resolved' && remainingCapacity > 1
    ) {
      message.success(responseMessage);
    }
    if (status === 'rejected') {
      message.error(getErrorMessage(responseData));
    }
  }, [
    requestIdentifier,
    remainingCapacity,
    responseMessage,
    errorMessage,
    status,
    responseData,
    sendRequest
  ]);

  useEffect(() => {
    if (remainingCapacity >= 0) {
      form.setFieldsValue({ remainingCapacity });
    }
    if (remainingCapacity === 0) {
      message.success('Η καταχώρηση του κιβωτίου ολοκληρώθηκε με επιτυχία');
    } else if (remainingCapacity === 1) {
      message.success(
        ` Έχει μείνει μια (${remainingCapacity}) κούτα για καταχώρηση `
      );
    }
  }, [remainingCapacity, form, excelColumns]);

  useEffect(() => {
    if (remainingCapacity === 0) {
      sendRequest(
        {
          endpoint: `${
            EndPoints.PACKING.GETLISTPACKING
          }/${parcelId}`,
          method: 'GET',
          data: null
        },
        'GETEXCELDATA'
      );
    }
  }, [remainingCapacity, sendRequest, parcelId]);

  

  const onFinsishPackage = () => {
    exportToExcel(excelColumns, excelData);
  };

  useEffect(() => {
    setUseNewSIMOnNewDevice(useNewSIM);
    if (isNew === true) setUseNewSIMOnNewDevice(false);
  }, [useNewSIM, isNew, useNewSIMOnNewDevice]);

  return (
    <Card type="inner">
      <PackingForm
        deviceType={deviceType}
        carrierCompany={carrierCompany}
        isNewPackageFormDisable="true"
        setBoxPackagesFromNewDevice={remainingCapacity}
        form={form}
        isDisplayPackageId="true"
        isDisabledOBDType="true"
        isDisplayUseNewSIM={isDisplayUseNewSIM}
        deviceTypeId={deviceTypeId}
      />
      <Form {...layout} form={newDeviceForm} onFinish={addnewDevice}>
        <Row>
          <Col span={24}>
            <Form.Item
              name="imei"
              label="ΙΜΕΙ Συσκευής"
              rules={[
                {
                  pattern:
                    deviceTypeId === GL
                      ? new RegExp(Validations.GL.REGEX)
                      : deviceTypeId === GDP
                      ? new RegExp(Validations.GDP.REGEX)
                      : deviceTypeId === PCL
                      ? new RegExp(Validations.PCL.REGEX)
                      : null,
                  message:
                    deviceTypeId === GL
                      ? Validations.GL.MESSAGE
                      : deviceTypeId === GDP
                      ? Validations.GDP.MESSAGE
                      : deviceTypeId === PCL
                      ? Validations.PCL.MESSAGE
                      : null,
                  required: true
                }
              ]}
            >
              <Input
                style={{textTransform:'uppercase'}}
                onKeyDown={onPreventFormSubmitByEnterKey}
                onChange={onChangeInputImeiDevice}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="imeiPackage" label="ΙΜΕΙ Συσκευασίας">
              <Input onKeyDown={onPreventFormSubmitByEnterKey} />
            </Form.Item>
          </Col>
          {deviceTypeId < PCL ? (
            <Col span={24}>
              <Form.Item
                name="imsi"
                label="ΙΜSΙ Sim Κάρτας"
                rules={[
                  {
                    required: true,
                    pattern: new RegExp(Validations.IMSISIM.REGEX),
                    message: Validations.IMSISIM.MESSAGE
                  }
                ]}
              >
                <Input
                  onKeyDown={onPreventFormSubmitByEnterKey}
                  disabled={!isNew}
                />
              </Form.Item>
            </Col>
          ) : (
            <Col span={24}>
              <Form.Item
                name="macAddress"
                label="MAC Address"
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <Input
                  disabled={!isNew}
                  onKeyDown={onPreventFormSubmitByEnterKey}
                />
              </Form.Item>
            </Col>
          )}
          <Col offset={2} span={10}>
            <Form.Item>
              <Button
                disabled={remainingCapacity === 0}
                style={{ backgroundColor: '#e6e6e6' }}
                htmlType='submit'
              >
                Καταχώρηση
              </Button>
            </Form.Item>
          </Col>
          <Col offset={2} span={10}>
            <Form.Item>
              <Button
                disabled={remainingCapacity > 0}
                onClick={onFinsishPackage}
                style={{ backgroundColor: '#e6e6e6' }}
              >
                Εξαγωγή EXCEL
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}
